import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class LoginReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/loginReport',
      requesterInfo,
    })
  }

  public async sendLoginExcel(req: any): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
